<template>
  <div v-if="type == 'list-item-full'">
    <label class="selector-label" for="">{{
      ("selector_" + titleKey) | setText(title)
    }}</label>
    <component
      :is="type"
      :modal="modal"
      :prefix="prefix"
      :url="url"
      :triggerOpen="triggerOpen"
      :simple="true"
      v-model="val"
      :params="params"
    />
  </div>
  <div v-else :class="`${disabled ? 'opacity' : ''}`">
    <label class="selector-label" for="">{{
      ("selector_" + titleKey) | setText(title)
    }}</label>
    <div class="selector">
      <ul v-if="value">
        <li v-for="v in val" :key="v.id">
          <span>
            {{ v[selectKey] }}
          </span>
          <span @click="clearItem(v.id)"> ✕ </span>
        </li>
      </ul>

      <div @click="open" class="background" />
      <span v-if="disabled !== true" @click="open" class="ti-angle-down"></span>
    </div>
    <component
      :is="type"
      :modal="modal"
      :prefix="prefix"
      :url="url"
      :triggerOpen="triggerOpen"
      :simple="true"
      v-model="val"
      :params="params"
    />
  </div>
</template>
<script>
export default {
  data: () => ({
    // val: null,
  }),

  props: {
    triggerOpen: {
      default: false,
    },
    type: {
      default: "list-item",
    },
    title: {
      default: "",
    },
    titleKey: {
      default: "",
    },
    url: {
      default: "",
    },
    modal: {
      default: "",
    },
    disabled: {
      default: false,
    },
    selectKey: {
      default: "title",
    },
    placeholder: {
      default: "",
    },
    prefix: {
      default: "",
    },
    fieldKey: {
      default: "",
    },
    params: {
      default: function () {
        return {};
      },
    },
    value: {
      default: function () {
        return {};
      },
    },
  },
  computed: {
    val: {
      get() {
        if (this.value && this.value.id) {
          return [this.value];
        }
        return [];
      },
      set(val) {
        if (val && val.length) {
          this.$emit("input", val[0], this.fieldKey);
        } else {
          this.$emit("input", null, this.fieldKey);
        }
      },
    },
  },
  mounted() {
    if (this.triggerOpen === true) {
      setTimeout(() => {
        this.open();
      }, 41);
    }
  },
  watch: {
    triggerOpen(val) {
      if (val === true) {
        this.open();
      }
    },
  },
  components: {
    "list-item": () => import("../Modals/ListItem"),
    "list-item-full": () => import("../Modals/ListItemFull"),
  },
  methods: {
    open() {
      if (this.disabled === true) {
        return false;
      }

      setTimeout(() => {
        this.$modal.show(`${this.modal}${this.prefix}`);
      }, 10);
    },
    clearItem(id) {
      this.val = [...this.val].filter((item) => {
        return item.id != id;
      });
    },
  },
};
</script>
<style lang="scss">
.selector {
  position: relative;

  & > .background {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
    background: #f4f4f4;
  }

  &-label {
    color: #888;
    font-size: 12px;
  }

  background: #fff;
  min-height: 38px;
  overflow: hidden;
  border: 1px solid #f4f4f4;
  border-radius: 12px;
  display: flex;
  width: 100%;
  align-items: center;
  text-align: left;
  margin-bottom: 15px;

  & > ul {
    list-style: none;
    padding: 0 0 0 5px;
    margin: 0;
    font-size: 16px;
    width: calc(100% - 40px);
    display: flex;
    flex-wrap: wrap;

    & > li {
      z-index: 1;
      margin: 3px;
      padding: 2px 5px 2px 5px;
      background: #000511;
      color: #fff;
      border-radius: 9px;
      display: flex;
      align-items: center;

      & > span {
        cursor: pointer;
        display: block;
        font-size: 14px;

        &:last-child {
          font-size: 12px;
          margin-left: 5px;

          &:hover {
            opacity: 0.6;
          }
        }
      }
    }
  }

  & > span {
    cursor: pointer;
    display: block;
    width: 40px;
    text-align: center;
    font-size: 7px;
    margin-right: auto;
  }
}
</style>